module.exports = __webpack_public_path__ + "static/media/recentFeedNormalHealth.910b2e5b.svg";